// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Content__Wrapper__RObaR","DateWrapper":"Content__DateWrapper__18NBM","WithHover":"Content__WithHover__2X4rd","Arrow":"Content__Arrow__2pfh4","ArrowLeft":"Content__ArrowLeft__3IkYj","ArrowRight":"Content__ArrowRight__4Cjs4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Content/Content.css
// module id = 104
// module chunks = 0